<template>
    <div>
        <div class>
            <Steps :active="4" :stepsShow=true align-center>
                <Step :title="$t('course.csbase')" @click.native="on_click('csbaseShow')" />
                <Step :title="$t('course.cscondition')" @click.native="on_click('csconditionShow')"/>
                <Step :title="$t('course.csprice')" @click.native="on_click('cspriceShow')" />
                <Step :title="$t('course.csrpt')" @click.native="on_click('csrptShow')" />
                <Step :title="$t('course.csinvest')" @click.native="on_click('csinvestShow')" />
                <Step :title="$t('course.csability')" @click.native="on_click('csabilityShow')" />
            </Steps>
        </div>
        <br/>
        <div class='divMessage' style=" word-wrap:break-word; word-break:break-all;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ message }}</div>
        <br/>
        <el-card class="aui-card--fill"
                 shadow="never">
            <el-form
                    label-position="left"
                    class="demo-dynamic"
            >
                <el-row>
                    <div class="investigationTitle">
                      {{$t('offering.courseInvestigation')}}
                      <el-tooltip placement="bottom-start" effect="light" >
                        <div slot="content">
                            <p>当前显示为默认问卷，如有需求可点击添加问卷更换其他问卷。若无需学员反馈课程满意度，此处可为空。</p>
                            <p>当前问卷的调整将同步到所有已发布/未发布排期，已结束排期不会发生变更。</p>
                        </div>
                        <em class="el-icon-question" style="color: #1C69D3"></em>
                      </el-tooltip>
                    </div>
                    <el-col :span="4"><div class="grid-content" /></el-col>
                    <el-col :span="10">
                        <el-table
                                ref="questionnaireTable"
                                :data="initQuestionnaireData.courseInvestigationList"
                                border
                                style="width: 100%">
                            <el-table-column
                                    prop="investigationName"
                                    align="center"
                                    :label="$t('offering.investigationName')"/>
                            <el-table-column
                                    prop="investigationAddress"
                                    align="center"
                                    :label="$t('offering.investigationAddress')"/>
<!--                            <el-table-column-->
<!--                                    align="center"-->
<!--                                    :label="$t('handle')"-->
<!--                                    width="120">-->
<!--                                <template slot-scope="scope">-->
<!--                                  <el-button size="text" disabled> 删除 </el-button>-->
<!--                                </template>-->
<!--                            </el-table-column>-->
                        </el-table>
                    </el-col>
                </el-row>
                <el-row>
                    <div class="investigationTitle">
                      {{$t('offering.trainerInvestigation')}}
                      <el-tooltip placement="bottom-start" effect="light" >
                        <div slot="content">

                            <p>当前显示为默认问卷，如有需求可点击添加问卷更换其他问卷。若无需学员反馈老师满意度，此处可为空。</p>
                            <p>当前问卷的调整将同步到所有已发布/未发布排期，已结束排期不会发生变更。</p>
                        </div>
                        <em class="el-icon-question" style="color: #1C69D3"></em>
                      </el-tooltip>
                    </div>
                    <el-col :span="4"><div class="grid-content" /></el-col>
                    <el-col :span="10">
                        <el-table
                                :data="initQuestionnaireData.trainerInvestigationList"
                                border
                                lazy
                                style="width: 100%">
                            <el-table-column
                                    prop="investigationName"
                                    align="center"
                                    :label="$t('offering.investigationName')"/>
                            <el-table-column
                                    prop="investigationAddress"
                                    align="center"
                                    :label="$t('offering.investigationAddress')"/>
<!--                            <el-table-column-->
<!--                                    align="center"-->
<!--                                    :label="$t('handle')"-->
<!--                                    width="120">-->
<!--                                <template slot-scope="scope">-->
<!--                                  <el-button size="text" disabled> 删除 </el-button>-->
<!--                                </template>-->
<!--                            </el-table-column>-->
                        </el-table>
                        <!--  -->
                    </el-col>
                </el-row>
            </el-form>
        </el-card>
        <div>
            <el-row  style="float:right; margin-bottom: 60px;">
                <el-col :span="16"><div class="grid-content" /></el-col>
                <el-button @click="sendEdit" v-if="checkEditRole()"
                           type="primary">{{ $t("course.edit") }}</el-button>
                <el-button @click="send"  type="primary">{{ $t("course.next") }}</el-button>
            </el-row>
        </div>
    </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import Steps from '../../common/steps/index'
import Step from '../../common/steps/src/step'
export default {
// import引入的组件需要注入到对象中才能使用
  components: { Steps, Step },
  props: ['message', 'issaveall', 'courseid'],
  inject: ['toTop'],
  data () {
    return {
      courseId: '',
      dialogTableVisible: false,
      dialogFlag: '',
      inServForm:{
          courseId: '1'
      },
      initQuestionnaireData: {
        courseId: '',
        courseInvestigationList: [],
        trainerInvestigationList: []
      }
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {
    this.init()
    this.inServForm.courseId = this.$route.query.courseId
    this.$eventHub.$on('showViewCourse', (data) => {
      console.log('showCourse csinvestShow ')
      this.init()
    })
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {
    console.log('mounted')
  },
  beforeCreate () {
    console.log('beforeCreate')
  }, // 生命周期 - 创建之前
  beforeMount () {
    console.log('beforeMount')
  }, // 生命周期 - 挂载之前
  beforeUpdate () {
    console.log('beforeUpdate')
  }, // 生命周期 - 更新之前
  updated () {
    console.log('updated')
  }, // 生命周期 - 更新之后
  beforeDestroy () {
    console.log('beforeDestroy')
  }, // 生命周期 - 销毁之前
  destroyed () {
    console.log('destroyed')
  }, // 生命周期 - 销毁完成
  activated () {
    this.init()
  },
  // 方法集合
  methods: {
    // 设置初始化为空
    again () {
      this.initQuestionnaireData = {}
    },
    // 初始化数据
    init () {
      console.log('init')
      this.courseId = this.$route.query.courseId
      if (this.courseId === undefined) {
        this.courseId = this.courseid

      }
      this.showDef(this.courseId)
    },
    showDef (newVal) {
      if (newVal !== '' && newVal !== undefined && newVal !== null) {
        if (this.initQuestionnaireData.courseInvestigationList.length === 0) {
          this.$request.get('/learning/courseinvestigation/' + newVal).then((res, total, code, data) => {
            if (data.data) {
              this.initQuestionnaireData = data.data
            }
          }).catch((err) => {
            console.log(err)
          })
        }
      }
    },
    // 点击导航跳转
    on_click (e) {
      this.$emit('onShowModer', e)
    },
    // 下一步
    send () {
      this.toTop()
      this.$emit('onShowModer', 'csabilityShow')
    },
    sendEdit(){
      console.log("sendEdit")
      console.log("csinvestShow ")
      console.log(this.inServForm.courseId)
      this.$router.push({ path: 'learning-course-course', query: { courseId: this.inServForm.courseId } })
    },
    checkEditRole () {
        return   this.$store.state.courseEdit
      // if (this.$hasPermission('learning:courseinfo:edit')) {
      //     return true
      // }
      // if (this.$hasPermission('TEAM:'+this.dataForm.courseTeamCatalogSecond)) {
      //     return true
      // }
      // if (this.$hasPermission('learning:courseinfo:editselfcreated')) {
      //     return true
      // }
      // return false
    },
  }
}
</script>
<style lang='scss' scoped>
    // @import url(); 引入公共css类
    .grid-content {
        border-radius: 4px;
        min-height: 20px;
    }
    .investigationTitle {
        padding: 20px;
        font-size: 15px;
        text-align: center;
        font-weight: bold;
        width: 80%;
    }
</style>
